export enum BlogCreationStatusEnum {
  Duplication = 'duplication',
  Sharing = 'sharing',
  Completed = 'completed',
}
